import { createFileRoute } from "@tanstack/react-router"
import { BigBlueAuthModal } from "modules/settings/components/integrations/bigblue/BigBlueAuthModal"

export const Route = createFileRoute("/_base/_auth/settings/integrations/bigblue/connect")({
  component: BigBlueAuthModal,
})
